import '/app/brewery-packages/content/content-editor-plugin-ordered-list/src/OrderedList.css-raw';
export default {
  "orderedList": "jobs-2ec46bc8-orderedList-Gei3fa"
};